'use client';

import { c as _c } from "react/compiler-runtime";
import type { CartItem } from '@sola/schema/dotcom/cart/cart-item.ts';
import { useBirthdayAppealCartItem } from './birthday-appeal-cart-item.logic.ts';
import { BirthdayAppeal } from './birthday-appeal.tsx';
export interface BirthdayAppealCartItemProps {
  item: CartItem;
  className?: string;
  background?: string;
  flush?: boolean;
}
export const BirthdayAppealCartItem: React.FC<BirthdayAppealCartItemProps> = t0 => {
  const $ = _c(10);
  const {
    item,
    className,
    background,
    flush
  } = t0;
  const {
    childName,
    amountOptions,
    defaultAmount,
    isEligible,
    isAdded,
    isBusy,
    onAdd,
    onRemove
  } = useBirthdayAppealCartItem(item);
  if (!isEligible || isAdded) {
    return null;
  }
  let t1;
  if ($[0] !== amountOptions || $[1] !== background || $[2] !== childName || $[3] !== className || $[4] !== defaultAmount || $[5] !== flush || $[6] !== isBusy || $[7] !== onAdd || $[8] !== onRemove) {
    t1 = <BirthdayAppeal className={className} background={background} flush={flush} childName={childName} amountOptions={amountOptions} defaultAmount={defaultAmount} isBusy={isBusy} onAdd={onAdd} onRemove={onRemove} />;
    $[0] = amountOptions;
    $[1] = background;
    $[2] = childName;
    $[3] = className;
    $[4] = defaultAmount;
    $[5] = flush;
    $[6] = isBusy;
    $[7] = onAdd;
    $[8] = onRemove;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};